/* eslint-disable import/prefer-default-export */
import { getPluginLifecycleHook } from 'reducers/Plugins';

import { RootState } from 'reducers';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { PatchScript } from '@pos-refacto/patchscript-with-react';
import { printPatchscript } from './integrations/printer';
import {
  CashInOutPrintPayload,
  CashInOutPrintExtra,
  prepareCashInOutData,
} from './integrations/printer/preparePrintoutData';

function createPatchScriptForCashInOut(
  printInfo: CashInOutPrintPayload & CashInOutPrintExtra,
): PatchScript {
  return [
    {
      pieces: [
        { meta: { bold: true, size: 2 }, text: printInfo.companyAndWarehouse },
      ],
      type: 'text',
    },
    { pieces: [{ text: ' ' }], type: 'text' },
    {
      pieces: [{ text: printInfo.address }],
      type: 'text',
    },
    { pieces: [{ text: printInfo.date }], type: 'text' },
    {
      pieces: [
        { text: printInfo.translations.sale.employee },
        {
          text: ': ',
          meta: {
            bold: false,
            underline: false,
          },
        },
        { text: printInfo.employee.employeeName },
      ],
      type: 'text',
    },
    { pieces: [{ text: ' ' }], type: 'text' },
    {
      columns: [
        { baseWidth: 6, weight: 0 },
        { baseWidth: 0, weight: 1 },
        { baseWidth: printInfo.sum.length + 1, weight: 0 },
      ],
      rows: [
        {
          cells: [
            {
              pieces: [
                {
                  text: printInfo.translations.defaults.notesTitle,
                },
              ],
            },
            {
              align: 'right',
              pieces: [
                {
                  text: printInfo.comment,
                  meta: {
                    bold: false,
                    underline: false,
                  },
                },
              ],
            },
            'colspan',
          ],
          type: 'normal',
        },
        {
          cells: [
            'colspan',
            {
              align: 'left',
              pieces: [],
            },
            {
              align: 'left',
              pieces: [],
            },
          ],
          type: 'sectionStart',
        },
        {
          cells: [
            null,
            {
              align: 'center',
              pieces: [{ meta: { bold: true }, text: printInfo.cashInOutText }],
            },
            {
              align: 'right',
              pieces: [{ meta: { bold: true }, text: printInfo.sum }],
            },
          ],
          type: 'normal',
        },
      ],
      type: 'table',
    },
  ];
}

export function printCashInOut(payload: CashInOutPrintPayload) {
  return async (
    dispatch: ThunkDispatch<RootState, unknown, Action<string>>,
    getState: () => RootState,
  ) => {
    const { before, on, after } = getPluginLifecycleHook('onCashInOutPrint')(
      getState(),
    );
    await dispatch(before(payload));

    const data = await dispatch(
      prepareCashInOutData(payload),
    );

    const cashInOutPatchScript: PatchScript = createPatchScriptForCashInOut(
      data,
    );

    const { patchScript } = await dispatch(
      on(payload, { data, patchScript: cashInOutPatchScript }),
    );

    await dispatch(printPatchscript(patchScript));

    await dispatch(after(payload, undefined));
  };
}
